import { Grid } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import AttributeValuesDataTable from '../../../../containers/attribute-values/AttributeValuesDataTable';

function AttributeSection({ display, title, id, hasAnyOfPrivilegesOnScopedResource }) {
  const { classes } = useStyles();
  const [isExpanded, setExpanded] = React.useState(true);

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"attributes"}>
      <EAAccordion
        title={title}
        logo="thirdparty/attributes"
        titleNoResult
        opened={isExpanded}
      >
        <AttributeValuesDataTable
          id={id}
          bondType="thirdparty"
          hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
          setExpanded={setExpanded}
        />
      </EAAccordion>
    </Grid>
  );
}

export default AttributeSection;
